export default __webpack_public_path__ + "static/media/heart.07658110.svg";